import { createFileRoute } from '@tanstack/react-router';

import { CompanyView } from '@/modules/Timesheets/CompanyView';

export const Route = createFileRoute('/app/timesheets/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      projectId: typeof search.projectId === 'number' ? search.projectId : undefined,
    };
  },
});

function RouteComponent() {
  const search = Route.useSearch();

  return <CompanyView initialProjectId={search.projectId} />;
}
